import { ReportTableColumn, ReportTableDropdown } from "../../models/reports.model";
import { WarehouseInventoryv2MenuEnum } from "./report-warehouse-inventory-v2.enum";
import { DataType } from "src/app/common/models/enums/common.enum";

export class WarehouseInventoryv2Constant {

    static overViewMenu = [
        {
            label: 'reports.overview',
            name: WarehouseInventoryv2MenuEnum.overview,
        },
         {
            label: 'reports.rentUnitSizeWise',
            name: WarehouseInventoryv2MenuEnum.unitSizeWise,
        },
        {
            label: 'reports.project',
            name: WarehouseInventoryv2MenuEnum.project,
        },
        {
            label: 'reports.landprices',
            name: WarehouseInventoryv2MenuEnum.landprices,
        },
        {
            label: 'reports.property_prices',
            name: WarehouseInventoryv2MenuEnum.propertyTransaction,
        }
    ]

    static unitSizeDropdown: ReportTableDropdown = {
        label: 'reports.show_price_in',
        data: [{
            value: 'Range',
            id: 'Range',
        }, {
            value: 'Average',
            id: 'Average',
        }],
        default: 'Range',
        maxSelect: 1,
        reportType: false
    }

    
    static warehouseUnitsizeColumns: ReportTableColumn[] = [
        {
            header: 'unit_size',
            columnName: 'reports.unit_size',
            field: 'unit_size',
            isSortable: false,
            border: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'dry_warehouse_range',
            columnName: 'reports.dry_warehouse',
            field: 'dry_warehouse_range',
            symbol: DataType.currencyWithSquareMeter,
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'dry_warehouse_avg',
        },

        {
            header: 'cold_storage_range',
            columnName: 'reports.cold_storage',
            field: 'cold_storage_range',
            symbol: DataType.currencyWithSquareMeter,
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'cold_storage_avg',
        },
        {
            header: 'frozen_warehouse_range',
            columnName: 'reports.frozen_warehouse',
            field: 'frozen_warehouse_range',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'frozen_warehouse_avg',
        },
        {
            header: 'ambient_range',
            columnName: 'reports.ambient',
            field: 'ambient_range',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'ambient_avg'
        }

    ]

    static inventoryProjectColumns: ReportTableColumn[] = [
        {
            header: 'project_name',
            columnName: 'reports.Project_Name_type',
            field: 'project_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            isAnchor: true,
            showOnMap: true,
        },
        {
            header: 'no_of_project',
            columnName: 'reports.No_of_Warehouses',
            field: 'no_of_project',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },

        {
            header: 'grade',
            columnName: 'reports.grade',
            field: 'grade',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            symbol: DataType.squareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'gross_leasable_area',
            columnName: 'reports.gross_built_area',
            field: 'gross_leasable_area',
             symbol: DataType.squareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'average_lease_rate',
            columnName: 'reports.lease_rate',
            field: 'average_lease_rate',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'neigh_name',
            columnName: 'reports.neighborhood',
            field: 'neigh_name',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        }

    ]

     static inventoryLandPriceColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.property_name_id',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            isAnchor: true,
            showOnMap: true,
        },
        {
            header: 'transaction_date',
            columnName: 'reports.transaction_date',
            field: 'transaction_date',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },

        {
            header: 'transaction_type',
            columnName: 'reports.transactionType',
            field: 'transaction_type',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            symbol: DataType.currencyCode,
            border: true,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            recordType: true
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
             symbol: DataType.squareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'land_area',
            columnName: 'reports.transaction_rate',
            field: 'land_area',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'parcel_no',
            columnName: 'reports.parcelNumber',
            field: 'parcel_no',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'project_name',
            columnName: 'reports.project',
            field: 'project_name',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            isAnchor:true,
            showOnMap:true,
        }
    ]


    static inventoryPropertyTransactionColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.property_name_id',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            isAnchor:true,
            showOnMap:true,
        },
        {
            header: 'transaction_date',
            columnName: 'reports.transaction_date',
            field: 'transaction_date',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },

        {
            header: 'transaction_type',
            columnName: 'reports.transactionType',
            field: 'transaction_type',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            symbol: DataType.currencyCode,
            border: true,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            recordType: true
        },
        {
            header: 'transaction_area',
            columnName: 'reports.transaction_area',
            field: 'transaction_area',
             symbol: DataType.squareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'transaction_rate',
            columnName: 'reports.transaction_rate',
            field: 'transaction_rate',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'cap_rate',
            columnName: 'reports.cap_rate',
            field: 'cap_rate',
            symbol: DataType.inBuiltUp,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
        },
         {
            header: 'project_name',
            columnName: 'reports.project',
            field: 'project_name',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap:true,
            isAnchor:true,
        }
    ]

    
}
